import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { EMPTY, Observable, catchError, take, tap } from "rxjs";
import { TreatmentState, UpsertTreatment } from "../store";
import { Store } from "@ngrx/store";
import { TreatmentModel } from "../models/treatment.model";
import { TreatmentsService } from "./treatments.service";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.service";

@Injectable()
export class TreatmentResolver {
	constructor(
		private treatmentsService: TreatmentsService,
		private notificationService: NotificationService,
		private store: Store<TreatmentState>
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TreatmentModel> {
		return this.treatmentsService.getTreatment(route.params.id).pipe(
			take(1),
			tap((treatment: TreatmentModel) =>
				this.store.dispatch(new UpsertTreatment({ treatment }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveTreatmentError", "", 5000);
				return EMPTY;
			})
		);
	}
}
